import styled from '@emotion/styled';

interface Props {
  src?: string;
  defaultPhoto?: string;
}

const StyledTableCell = styled.div`
  padding: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const StyledImage = styled.img`
  width: 100%;
  height: 100%;
`;

export const ImageCell = ({ src, defaultPhoto = '' }: Props) => {
  const useDefaultPhoto = !src && defaultPhoto;

  if (useDefaultPhoto) {
    return (
      <StyledTableCell>
        <StyledImage src={defaultPhoto} />
      </StyledTableCell>
    );
  }

  return (
    <StyledTableCell>
      <StyledImage src={src} />
    </StyledTableCell>
  );
};
